// Normalization helpers for chart datasets
// Accepts arrays in any of these shapes:
// - number[] (indexes become x)
// - {x, y}
// - {date, value} / {date, price}
// - {timestamp, value}
// - tuple [x,y]
// Returns: {x: string|number|Date, y: number}[]
export type AnyPoint = any;

export function normalizeSeries(raw: AnyPoint[] | undefined | null): {x:any, y:number}[] {
  if (!raw || !Array.isArray(raw)) return [];
  return raw
    .map((p, i) => {
      if (p == null) return null;
      if (typeof p === 'number') return { x: i, y: p };
      if (Array.isArray(p) && p.length >= 2) return { x: p[0], y: Number(p[1]) };
      if (typeof p === 'object') {
        const x = p.x ?? p.date ?? p.timestamp ?? p.t ?? p.time ?? i;
        const y = p.y ?? p.value ?? p.price ?? p.v ?? p.close ?? p.avg ?? p.amount;
        if (x == null || y == null) return null;
        return { x, y: Number(y) };
      }
      return null;
    })
    .filter(Boolean) as {x:any,y:number}[];
}

